export const payoutMassiveConfirmStatusMap = {
  'SUCCESS': "Los payouts han sido confirmados correctamente",
  'ERROR': 'Se produjo un error al intentar confirmar los payouts masivos'
};
